import { resourcesType } from "../constanst/index";

import { resourcesAction } from "../actions/IResourcesAction";
import { ActionWithPayload } from "../types/ActionsType";
import { ResourceSelected, resourcesState } from "../types/resourceType";
import { Exception } from "../types/exceptionType";

let error: Exception = { status: "", message: "", data: {} };
let resourceSelected: ResourceSelected = {
  id: "",
  name: "",
  type:""
};
const initialState = {
  resources: {
    loading: false,
    data: [],
    error: error,
  },
  resourceSelected: resourceSelected,
};

const resourcesReducer = (
  state = initialState,
  action: ActionWithPayload<resourcesAction>
): resourcesState => {
  switch (action.type) {
    case resourcesType.FETCH_RESOURCES_REQUEST:
      return {
        ...state,
        resources: {
          ...state.resources,
          loading: true,
        },
      };

    case resourcesType.FETCH_RESOURCES_SUCCESS:
      return {
        ...state,
        resources: {
          loading: false,
          data: action.payload,
          error: error,
        },
      };
    case resourcesType.FETCH_RESOURCES_FAILURE:
      return {
        ...state,
        resources: {
          loading: false,
          data: [],
          error: action.payload,
        },
      };
    case resourcesType.RESOURCE_SELECTED:
      return {
        ...state,
        resourceSelected: { ...action.payload },
      };
    case resourcesType.CLEAN_RESOURCES:
      return initialState;
    default:
      return state;
  }
};

export default resourcesReducer;
